import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import TextField from 'material-ui/TextField';
import WaitingModal from '../../generics/WaitingModal';
import ModalPrintLabel from '../../generics/ModalPrintLabel';
var Config = require('../../../config');

class ModalMultipleRecords extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.createRecords = this.createRecords.bind(this);
		this.openModalLabel = this.openModalLabel.bind(this);
		this.state = {
		    show: false,
			show_start: false,
		    num_records:"",
			num_start:"",
		    errorText_num_records:"",
			errorText_num_start:"",
			priority:3,
			errorText_priority:''
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow() {
		fetch(Config.default.apiGateway.URL+'caller_actions_history/get_secuence_type?hf_id=' + sessionStorage.getItem('health_facilities_id') ,{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
		  	if(res.ok){
				return res.json();
			}
		})
		.then(response => {
			if(response !== undefined){
				//this.setState({ show_start: response});
			}
		});

		this.setState({ num_start: "1" });
		this.setState({ num_records: "1" });
		this.setState({ show: true});
	}

	//Evento de cambio en elementos formulario
	handleChange = (event, index, value) => {
	
	    this.setState({
	      [event.target.name]: event.target.value
	    });

	    if(event.target.required){
	    	if (event.target.value.length > 0) {
	    		this.setState({['errorText_'+event.target.name]: ""})
				if(document.getElementById(event.target.name) !== null){
					document.getElementById(event.target.name).classList.remove('error')
				}
	    	} else{
	    		this.setState({['errorText_'+event.target.name]: "Campo obligatorio"})
				if(document.getElementById(event.target.name) !== null){
					document.getElementById(event.target.name).classList.add('error')
				}
	    	};
	    }

	}

	openModalLabel(type, id, extraction, print){
		this.modal_print_label.handleShow(type,id, extraction, print, this.props.preview_print, 'offers');
	}

	createRecords(){
		if(this.isValidForm()){
			this.waiting_modal.handleShow('Generando...');
			var obj = {
				num_records: this.state.num_records,
				num_start: this.state.num_start,
				priority: this.state.priority,
				health_facilities_id: sessionStorage.getItem("health_facilities_id")
			};

	      	fetch(Config.default.apiGateway.URL+'caller_actions_history', {
			  method: 'POST', // or 'PUT',
			  body: JSON.stringify(obj), // data can be `string` or {object}!
			  headers: new Headers({
			  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
			  	'Accept': 'application/json',
			  	'Content-Type': 'application/json;charset=UTF-8'
			  })
			}).then(res => {
				this.waiting_modal.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(function(result) {
						swal('¡Error!', result, 'error');
					});
				}})
			.then(response => {
		    	if(response !== undefined){
		    		this.setState({ show: false});
		    		//this.openModalLabel('label_caller', response.id, null, true)
					this.props.refresh();
					
		    	}
			})
			.catch(function(error) {
			  console.log('There has been a problem with your fetch operation: ' + error.message);
			});
		}else{
			swal('¡Error!', 'Campos Incompletos', 'error');
		}
	}

	//Verificar si el formulario es valido
	isValidForm() {

	    const inputs = document.querySelectorAll('input, select');
	    let isFormValid = true;
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showInputError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	 
	    
	    return isFormValid;
	}

	//Desplegar error en campos requeridos
	showInputError(refName) {
	    const validity = this.state[refName];
	    if (validity === '') {//console.log('vacio')
	    	this.setState({['errorText_'+refName]: "Campo obligatorio"})
			if(document.getElementById(refName) !== null){
				document.getElementById(refName).classList.add('error')
			}
	      	return false;
	    }else {//console.log('valor')
	    	this.setState({['errorText_'+refName]: ""})
			if(document.getElementById(refName) !== null){
				document.getElementById(refName).classList.remove('error')
			}
	    }
	    return true;
	}

	render(){
		const { t } = this.props;
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_multiple_record.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		 					<div className="col-xs-4" >
		 						<span className="span-ui">{t('content.modal_multiple_record.num_records')}:</span>
		 					</div>
		 					<div className="col-xs-4">
						        <TextField 
						        required
				 				fullWidth={true} 
				 				type="number"
				 				min="1"
				 				ref="num_records" name="num_records" 
				 				value={ this.state.num_records } 
				 				onChange={ this.handleChange } 
				 				errorText= {this.state.errorText_num_records} 
				 				/>
					        </div>
				        </div>						
						{ this.state.show_start ?
						<div className="col-xs-12">
		 					<div className="col-xs-4" >
		 						<span className="span-ui">Número de inicio:</span>
		 					</div>
		 					<div className="col-xs-4">
						        <TextField
				 				fullWidth={true} 
				 				type="number"
				 				min="1"
				 				ref="num_start" name="num_start" 
				 				value={ this.state.num_start } 
				 				onChange={ this.handleChange } 
				 				errorText= {this.state.errorText_num_start} 
				 				/>
					        </div>
				        </div>
						: null
						}
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.createRecords}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				<ModalPrintLabel {...this.props} onRef={ref => (this.modal_print_label = ref)} directPrint={this.props.directPrint}/>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalMultipleRecords);